<script>
    import classifieds from "../../stores/classifieds.js";
    import Preview from "./Preview.svelte";

    export let window;
</script>

<Preview
    store={classifieds}
    unit="local classifieds"
    sourceTitle="craigslist"
    {window}
/>
